const url = require('./url');

/**
 * Convert a camelCase string to snake_case.
 * @param {string} camelCase
 * @returns {string}
 */
function convertCamelCaseToSnakeCase(camelCase) {
	const firstCharacter = camelCase[0];
	const snakeCaseCharacters = [firstCharacter];
	const remainingCharacters = camelCase.slice(1).split('');
	let previousCharacter = firstCharacter;

	remainingCharacters.forEach((character) => {
		if (
			character === character.toUpperCase() &&
			Number.isNaN(+(character + previousCharacter))
		) {
			snakeCaseCharacters.push(`_${character.toLowerCase()}`);
		} else {
			snakeCaseCharacters.push(character);
		}

		previousCharacter = character;
	});

	return snakeCaseCharacters.join('');
}

/**
 * Convert a snake_case string to camelCase.
 * @param {string} snakeCase
 * @returns {string}
 */
function convertSnakeCaseToCamelCase(snakeCase) {
	const words = snakeCase.split('_');
	const firstWord = words[0];
	const camelCaseWords = [firstWord];
	const remainingWords = words.slice(1);

	remainingWords.forEach((word) => {
		const firstCharacter = word[0];
		const remainingCharacters = word.slice(1);

		camelCaseWords.push(
			`${firstCharacter.toUpperCase()}${remainingCharacters}`
		);
	});

	return camelCaseWords.join('');
}

/**
 * @param {string} camelCase
 * @returns {string}
 */
function convertCamelCaseToTitleCase(camelCase) {
	const titleCaseCharacters = [camelCase[0].toUpperCase()];
	const remainingCamelCase = camelCase.slice(1);

	/* eslint-disable-next-line no-restricted-syntax */
	for (const character of remainingCamelCase) {
		if (character === character.toUpperCase()) {
			titleCaseCharacters.push(` ${character}`);
		} else {
			titleCaseCharacters.push(character);
		}
	}

	return titleCaseCharacters.join('');
}

/**
 * @param {string} string
 * @param {string=} space
 * @returns {string}
 */
function convertToTitleCase(string, space = '') {
	if (typeof string !== 'string') {
		return '';
	}

	const lowerCase = string.toLowerCase();
	const words = lowerCase.split(' ');
	// eslint-disable-next-line no-confusing-arrow
	const titleCasedWords = words.map((word) => word ? word[0].toUpperCase() + word.slice(1) : ''); // prettier-ignore

	return titleCasedWords.join(space).trim();
}

/**
 * @param {string} string
 * @returns {boolean}
 */
function isNumeric(string) {
	return !isNaN(parseInt(string));
}

/**
 * @param {string} text
 * @param {number} charLength
 * @returns {string}
 */
function truncate(text, charLength) {
	if (typeof text !== 'string' || text?.length < charLength) {
		return text;
	}

	if (/\s/.test(text.charAt(charLength))) {
		return `${text.slice(0, charLength)}...`;
	}

	const nextWhitespace = text.slice(charLength, text.length).indexOf(' ');

	return `${text.slice(0, charLength + nextWhitespace)}...`;
}
/**
 * @deprecated Use `url` module
 * @param {string} string
 * @returns {string}
 */
function rawurlencode(string) {
	return url.rawurlencode(string);
}

/**
 * Similar to `sprintf` in other languages, replaces `%s` in order of the arguments passed.
 * @param {string} string
 * @param {...string} replacementList
 * @returns {string}
 */
function resolvePlaceholders(string, ...replacementList) {
	let formatted = string;

	replacementList.forEach((replacement) => {
		formatted = formatted.replace('%s', replacement);
	});

	return formatted;
}

/**
 * @param {string} name
 * @returns {{ first: string, last: string }}
 */
function splitNames(name) {
	const partList = name.split(' ');

	return {
		first: partList.shift() ?? '',
		last: partList.join(' '),
	};
}

module.exports = {
	convertCamelCaseToSnakeCase,
	convertCamelCaseToTitleCase,
	convertSnakeCaseToCamelCase,
	convertToTitleCase,
	isNumeric,
	rawurlencode,
	resolvePlaceholders,
	splitNames,
	truncate,
};
